import { ProductAttributes, ProductKeys } from './ProductEnums';

export const PRODUCT_VARIANT_FILTERS = [
  ProductKeys.color,
  ProductKeys.capacity,
  ProductKeys.capacityUnit,
  ProductKeys.capacityType,
];

export const ESSENTIAL_OILS_FILTERS = [
  ProductAttributes.beautyProblems,
  ProductAttributes.homeProblems,
  ProductAttributes.wellnessProblems,
  ProductAttributes.kitchenProblems,
];

export const PRODUCT_ATTRIBUTES_FILTERS = [
  ProductAttributes.mainCategory,
  ProductAttributes.culture,
  ProductAttributes.hairType,
  ProductAttributes.typeOfSkins,
  ProductAttributes.olfactoryUniverse,
  ProductAttributes.suitableFor,
  ProductAttributes.beautyProblems,
  ProductAttributes.beautyProperties,
  ProductAttributes.homeProblems,
  ProductAttributes.wellnessProblems,
  ProductAttributes.wellnessProperties,
  ProductAttributes.kitchenProblems,
];

export const PROPERTY_LABELS = [ProductAttributes.wellnessProperties, ProductAttributes.beautyProperties];

export const PROBLEM_LABELS = [
  ProductAttributes.beautyProblems,
  ProductAttributes.homeProblems,
  ProductAttributes.wellnessProblems,
  ProductAttributes.kitchenProblems,
];

export const PROBLEM_TYPE = ProductAttributes.issues;
export const PROPERTY_TYPE = ProductAttributes.properties;
